/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';
import { dynamicAssets } from '../../../../../utilities/helpers';

export const EmptyTransactionsImage = ({ emptySearchResult = false }) => (
  <img
    alt="No Card"
    className="empty-transaction-image"
    src={
      emptySearchResult
        ? dynamicAssets('./assets/images/no-deposit.png')
        : dynamicAssets('./assets/images/no-transactions.svg')
    }
  />
);

EmptyTransactionsImage.propTypes = {
  emptySearchResult: PropTypes.bool.isRequired,
};
